//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/NXObject.js";
import "../no/CDF.js";
import "../no/WidthDefinition.js";
let d=[[[0,"Colors",1,0],[0,"UseDrawingSheetColors",1,0],[0,"UseDrawingSheetWidths",1,0],[0,"Widths",1,0]],[[[],"DefinePalette",{},0,0],[[],"DefineWidths",{},0,0],[[],"RetrieveColors",{},0,0],[[],"SaveColors",{},0,0],[[],"EditColors",{},0,0],[[],"DeleteColors",{},0,0],[[],"ResetColors",{},0,0],[[],"RetrieveWidths",{},0,0],[[],"SaveWidths",{},0,0],[[],"EditWidths",{},0,0],[[],"DeleteWidths",{},0,0],[[],"ResetWidths",{},0,0],[[],"CreateCdf",{R_:{cdf:"CDF"}},0,0],[[],"GetCdf",{R_:{cdf:"CDF"}},0,0],[[],"CreateWidthDefinition",{R_:{widthDefinition:"WidthDefinition"}},0,0],[[],"GetWidthDefinition",{R_:{widthDefinition:"WidthDefinition"}},0,0]],[]];
SPLM.PlotColorsWidthsBuilder = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PlotColorsWidthsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PlotColorsWidthsBuilder.Color = Object.freeze({
    "AsDisplayed" : "AsDisplayed", "PartColors" : "PartColors", "CustomPalette" : "CustomPalette", "BlackOnWhite" : "BlackOnWhite", "LegacyColors" : "LegacyColors", "ColorsByWidth" : "ColorsByWidth"});

SPLM.PlotColorsWidthsBuilder.Width = Object.freeze({
    "StandardWidths" : "StandardWidths", "SingleWidth" : "SingleWidth", "CustomThreeWidths" : "CustomThreeWidths", "CustomPalette" : "CustomPalette"});

export default SPLM;